import script from "./SubMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SubMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SubMenu.vue?vue&type=style&index=0&id=78d78b3c&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78d78b3c"]])

export default __exports__